<template>
  <div class="Page">
    <div class="location Page-Content">
      <div class="location-img">
        <img  ondragstart="return false;" src="@/assets/172-img/map.png" alt="">
      </div>
    </div>

  </div>

</template>


<script>

export default {

  data() {
    return {
    
    }
  },
  methods: {
   
  },
  mounted(){
    // this.nowLocation = this.LocationList[0]
    // this.nowUnit = this.nowFloor.TypeList[0]
  }
}
</script>

<style lang="less">

  .location{
    .location-img{
      width:100%;
      height:100%;
      z-index: 120;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
    }
    
  }


</style>


